import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));

export const workPerformanceRoutes = [
  {
    page: MainPage,
    path: pathRoutes.workPerformance,
    screenCode: SCREEN.IP_003,
  },
];
